<template>
  <component :is="`${level}`" class="Tph-Title" :class="get_titleModifier">
    <slot />
  </component>
</template>

<script setup>
  //#TypographyTitle
  //---------------------------------
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  const props = defineProps(Props());
  //--------------------------
  const get_titleModifier = computed(() => `Tph-Title--${props.level}`)
</script>

<style lang="scss">
  @import './styles/style';
</style>
